<template>
  <span class="mb-4">
    <span :class="['mr-2', product == 'FWSED' ? 'mt-2' : '']" v-if="!onlyIcon">{{ product }}</span>
    <img v-if="product != 'PLATFORM'" v-b-tooltip.hover :title="product" :class="['mr-2 ', product == 'FWSED' ? 'mt-2' : '']" :src="icon" width="22" />
    <i v-else class="iconoir-cube-hole mt-2 text-warning font-size-16" v-b-tooltip.hover :title="product"></i>
  </span>
</template>

<script>
export default {
  props: ["product", "onlyIcon"],

  computed: {
    icon() {
      if (this.product == "FWSED") {
        return "/icons/fwsed-active.svg";
      }
    },
  },
};
</script>
